/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SecondaryDiagnosisDtoDiagnosisType =
  (typeof SecondaryDiagnosisDtoDiagnosisType)[keyof typeof SecondaryDiagnosisDtoDiagnosisType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SecondaryDiagnosisDtoDiagnosisType = {
  HIV: 'HIV',
  DIABETES: 'DIABETES',
  CORONARY_HEART_DISEASE: 'CORONARY_HEART_DISEASE',
  C2_ABUSE: 'C2_ABUSE',
  MENTAL_HEALTH: 'MENTAL_HEALTH',
  POLY_DRUG_USE: 'POLY_DRUG_USE',
  CA: 'CA',
} as const;
